import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined'
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined'
import { IconProps, SvgIconTypeMap } from '@mui/material'
import { OverridableComponent } from '@mui/material/OverridableComponent'

export namespace ClassType {
  export class Enum {
    static readonly INDIVIDUAL = new Enum(1, 'INDIVIDUAL', 'Aula individual', PersonOutlinedIcon)

    static readonly GROUP = new Enum(2, 'GROUP', 'Aula em Grupo', PeopleOutlinedIcon)

    public constructor(
      public readonly id: number,
      public readonly name: string,
      public readonly title: string,
      public readonly icon?: OverridableComponent<SvgIconTypeMap<object, 'svg'>>
    ) {}

    public get Icon() {
      return this.icon as React.ComponentType<IconProps>
    }
  }

  export const getByName = (name: string): Enum => {
    return Object.values(ClassType.Enum).find(type => type.name === name)
  }

  export const getById = (id: number | undefined): Enum | undefined => {
    return Object.values(ClassType.Enum).find(type => type.id === id)
  }
}
